/**
 * Favorites System - Product, Coloris & Article Wishlist
 * Handles adding/removing products/coloris/articles to user favorites
 */

document.addEventListener("DOMContentLoaded", function () {
  // =============================================================================
  // ADD TO FAVORITES BUTTON in main.js to ensure it works on both product and coloris pages
  // =============================================================================

  // =============================================================================
  // LOAD FAVORITES IN PROJECT SPACE
  // =============================================================================

  const favoritesContainer = document.getElementById("favorites-container");

  if (favoritesContainer) {
    loadFavorites();
  }

  function loadFavorites() {
    favoritesContainer.innerHTML =
      '<p class="text-grey-darker animate-pulse">Chargement de vos inspirations...</p>';

    const formData = new FormData();
    formData.append("action", "get_favorites");

    fetch(ajax.url, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          displayFavorites(data.data.favorites);
        } else {
          favoritesContainer.innerHTML =
            '<p class="text-grey-darker">Erreur lors du chargement de vos inspirations.</p>';
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        favoritesContainer.innerHTML =
          '<p class="text-grey-darker">Erreur réseau.</p>';
      });
  }

  function displayFavorites(favorites) {
    if (!favorites || favorites.length === 0) {
      favoritesContainer.innerHTML = `
        <div class="text-center py-12">
          <p class="text-grey-darker text-lg mb-4">Vous n'avez pas encore d'inspirations.</p>
          <p class="text-grey-dark mb-6">Parcourez notre catalogue et ajoutez vos produits favoris !</p>
          <div class="flex flex-row justify-between">
          <a href="/fenetres/" class="inline-block text-primary px-6 py-3 rounded-[2px] underline underline-offset-2 text-base font-bold transition-colors">
            Nos fenêtres
          </a>
           <a href="/portes-d-entree/" class="inline-block text-primary px-6 py-3 rounded-[2px] underline underline-offset-2 text-base font-bold transition-colors">
            Nos portes
          </a>
          <a href="/baies-vitrees/" class="inline-block text-primary px-6 py-3 rounded-[2px] underline underline-offset-2 text-base font-bold transition-colors">
            Nos baies vitrées
          </a>
            <a href="/actualites/" class="inline-block text-primary px-6 py-3 rounded-[2px] underline underline-offset-2 text-base font-bold transition-colors">
            Nos actualités
          </a>
          </div>
        </div>
      `;
      return;
    }

    // Separate items by type
    const products = favorites.filter((item) => item.type === "product");
    const coloris = favorites.filter((item) => item.type === "coloris");
    const posts = favorites.filter((item) => item.type === "post");

    let html = "";

    // Display products first
    if (products.length > 0) {
      html +=
        '<h3 class="text-base md:text-lg lg:text-xl font-bold text-black-primary mb-4">Produits</h3>';
      html +=
        '<div class="grid grid-cols-2 sm:grid-cols-3 gap-4 lg:gap-6 mb-8">';
      products.forEach((item) => {
        html += renderFavoriteCard(item);
      });
      html += "</div>";
    }

    // Display coloris
    if (coloris.length > 0) {
      html +=
        '<h3 class="text-base md:text-lg lg:text-xl font-bold text-black-primary mb-4">Coloris</h3>';
      html +=
        '<div class="grid grid-cols-2 sm:grid-cols-3 gap-4 lg:gap-6 mb-8">';
      coloris.forEach((item) => {
        html += renderFavoriteCard(item);
      });
      html += "</div>";
    }

    // Display articles (réalisations, etc.)
    if (posts.length > 0) {
      html +=
        '<h3 class="text-base md:text-lg lg:text-xl font-bold text-black-primary mb-4">Articles</h3>';
      html += '<div class="grid grid-cols-2 sm:grid-cols-3 gap-4 lg:gap-6">';
      posts.forEach((item) => {
        html += renderFavoriteCard(item);
      });
      html += "</div>";
    }

    html += `
      <div class="flex flex-row justify-between mt-6">
        <a href="/fenetres/" class="inline-block text-primary px-6 py-3 rounded-[2px] underline underline-offset-2 text-base font-bold transition-colors">
          Nos fenêtres
        </a>
        <a href="/portes-d-entree/" class="inline-block text-primary px-6 py-3 rounded-[2px] underline underline-offset-2 text-base font-bold transition-colors">
          Nos portes
        </a>
        <a href="/baies-vitrees/" class="inline-block text-primary px-6 py-3 rounded-[2px] underline underline-offset-2 text-base font-bold transition-colors">
          Nos baies vitrées
        </a>
        </a>
            <a href="/actualites/" class="inline-block text-primary px-6 py-3 rounded-[2px] underline underline-offset-2 text-base font-bold transition-colors">
            Nos actualités
          </a>
      </div>
    `;

    favoritesContainer.innerHTML = html;

    // Attach remove handlers
    document.querySelectorAll(".remove-favorite").forEach((btn) => {
      btn.addEventListener("click", function () {
        removeFavorite(this.dataset.itemType, this.dataset.itemId);
      });
    });
  }

  function renderFavoriteCard(item) {
    const imageUrl =
      item.image && item.image.url
        ? item.image.url
        : "/wp-content/themes/data_theme/assets/images/placeholder-product.jpg";
    const imageAlt = item.image && item.image.alt ? item.image.alt : item.title;

    // Badge HTML for products (if exists)
    const badgeHtml =
      item.badge && item.badge.url
        ? `<img src="${item.badge.url}" alt="${item.badge.alt || "Badge"}" class="absolute bottom-2 left-2 w-auto h-auto max-w-[80px] z-10" loading="lazy" />`
        : "";

    return `
      <div class="bg-white border border-gray-200 rounded-[2px] overflow-hidden transition-shadow group relative">
        <a href="${item.permalink}" class="block">
          <div class="aspect-[4/3] overflow-hidden bg-gray-100 relative">
            ${
              imageUrl
                ? `<img src="${imageUrl}" alt="${imageAlt}" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" />`
                : `<div class="w-full h-full bg-[#ddd] rounded-tl-[2px] rounded-tr-[2px] flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="99" height="114" viewBox="0 0 99 114" fill="none">
                                            <g opacity="0.5">
                                                <path d="M98.5956 80.3612L57.1461 92.3349V3.99351L98.5956 0V80.3612Z" fill="#AEAEAE" />
                                                <path d="M51.8338 93.8699L0 108.843V9.50034L51.8338 4.50552V93.8699Z" fill="#AEAEAE" />
                                                <path d="M42.2257 114L0 108.843V9.50034L42.2257 14.659V114Z" fill="#676A72" />
                                            </g>
                                        </svg>
                                    </div>`
            }
            ${badgeHtml}
          </div>
          <div class="p-2.5 sm:p-4">
            <h3 class="text-base md:text-lg font-medium text-black-primary group-hover:text-primary transition-colors line-clamp-2">${item.title}</h3>
          </div>
        </a>
        <div class="px-2.5 sm:px-4 pb-2.5 sm:pb-4 flex justify-between items-center">
          <a href="${item.permalink}" class="text-sm text-primary underline hover:text-primary-dark">
            Voir ${item.type === "product" ? "le produit" : item.type === "coloris" ? "le coloris" : "l'article"}
          </a>
          <button class="remove-favorite text-grey-dark hover:text-red-600 transition-colors p-1"
                  data-item-type="${item.type}"
                  data-item-id="${item.id}"
                  title="Supprimer des favoris"
                  aria-label="Supprimer des favoris">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
              <path d="M0 4.15909H16M6 7.56818V12.3409M10 7.56818V12.3409M5.33333 4.15909V3.47727C5.33333 1.97104 6.52724 0.75 8 0.75C9.47273 0.75 10.6667 1.97104 10.6667 3.47727V4.15909M2 4.15909H14V15.75H2V4.15909Z" stroke="currentColor" stroke-width="1.5"/>
            </svg>
          </button>
        </div>
      </div>
    `;
  }

  function removeFavorite(itemType, itemId) {
    window.openConfirmModal(
      "Voulez-vous vraiment retirer cet élément de vos favoris ?",
      function () {
        doRemoveFavorite(itemType, itemId);
      },
    );
  }

  function doRemoveFavorite(itemType, itemId) {
    const formData = new FormData();
    formData.append("action", "remove_from_favorites");

    if (itemType === "product") {
      formData.append("product_id", itemId);
    } else if (itemType === "coloris") {
      formData.append("coloris_id", itemId);
    } else if (itemType === "post") {
      formData.append("post_id", itemId);
    }

    fetch(ajax.url, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          // Reload favorites
          loadFavorites();
          showToast(data.data.message || "Élément retiré des favoris.");
        } else {
          showToast(data.data.message || "Une erreur est survenue.");
        }
      })
      .catch((error) => {
        console.error("Error removing favorite:", error);
        loadFavorites();
      });
  }

  // =============================================================================
  // UTILITY FUNCTIONS
  // =============================================================================

  function showToast(message) {
    const toast = document.createElement("div");
    toast.className =
      "fixed bottom-4 right-4 bg-primary text-base text-white px-6 py-3 rounded-[2px] shadow-lg z-50 animate-fade-in";
    toast.textContent = message;
    document.body.appendChild(toast);

    setTimeout(() => {
      toast.classList.add("animate-fade-out");
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 300);
    }, 3000);
  }

  // =============================================================================
  // UTILITY FUNCTIONS in main.js to ensure they work across all pages
  // =============================================================================
});
